module.exports = __webpack_public_path__ + "static/media/arrow-left.674a196a.svg";